import styled from "styled-components";

export const ButtonDelete = styled.button`
  margin-left: 5px;
  padding: 0px 5px;
`;

export const ListField = styled.ul`
  list-style: none;
`;

export const ItemField = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  border-bottom: 1px solid #ccc;
`;

export const PageHeader = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;

  h3 {
    color: #203b34;
    font-size: 28px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }
`;

export const BreadcrumbDiv = styled.div`
  margin: 0 !important;
  padding: 0 !important;

  .row {
    margin: 0 !important;
    justify-content: flex-start !important;
  }

  .breadcrumb {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
  }

  .breadcrumb-item {
    margin: 0 !important;
    padding: 0 !important;
  }
`;

export const FormContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;

  @media (max-width: 768px) {
    padding: 20px;
  }

  /* Estilos para inputs numéricos */
  .inputForm.inputText {
    width: 100%;
    padding: 0.625rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
      color: #495057;
      background-color: #fff;
      border-color: #80bdff;
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    &:disabled,
    &[readonly] {
      background-color: #e9ecef;
      opacity: 1;
    }
  }

  /* Estilos para labels */
  .control-label {
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: #495057;
    display: inline-block;

    &.mandatory::after {
      content: "";
      margin-left: 0;
    }
  }
`;

export const SectionTitle = styled.h5`
  color: #203b34;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  /* border-bottom: 2px solid #f9ae17; */
  display: inline-block;
`;
